import { Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Common/Header/Header";
import Footer from "./components/Common/Footer/Footer";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Destinations from "./pages/Destinations/Destinations";
import Services from "./pages/Services/Services";
import Blogs from "./pages/Blogs/Blogs";
import PhotoGallery from "./pages/PhotoGallery/PhotoGallery";
import Contact from "./pages/Contact/Contact";
import Bills from './pages/Bills/Bills';
import DetailBlog from "./pages/Blogs/DetailBlog";
import SearchTrip from "./pages/SearchTrip/SearchTrip";
import Booking from "./pages/Booking/Booking";
import PaymentSuccess from "./pages/Booking/PaymentSuccess";
import TermsAndConditions from "./pages/Extras/TermsAndConditions";
import PrivacyPolicy from "./pages/Extras/PrivacyPolicy";
import ValidationInvoice from "./pages/Extras/ValidationInvoice";
import ValidationPackage from "./pages/Extras/ValidationPackage";
import PaymentFailure from "./pages/Booking/PaymentFailure";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="nosotros" element={<About />} />
        <Route path="destinos" element={<Destinations />} />
        <Route path="servicios" element={<Services />} />
        <Route path="blog" element={<Blogs />} />
        <Route path="detalle-blog/:id" element={<DetailBlog />} />
        <Route path="galeria" element={<PhotoGallery />} />
        <Route path="contacto" element={<Contact />} />
        <Route path="factura" element={<Bills />} />
        <Route path="buscar-viaje" element={<SearchTrip />} />
        <Route path="realizar-pago" element={<Booking />} />
        <Route path="pago-exitoso" element={<PaymentSuccess />} />
        <Route path="pago-fallido" element={<PaymentFailure />} />
        <Route path="terminos-y-condiciones" element={<TermsAndConditions />} />
        <Route path="politicas-de-privacidad" element={<PrivacyPolicy />} />
        <Route path="boleto/:invoice" element={<ValidationInvoice />} />
        <Route path="paquete/:invoice" element={<ValidationPackage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
